<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-lg-12">
        <order-filter
            @marketplace="setMarketplaceQuery"
            @date="setDateQuery"
            @fulfilment="setFulfilment"
        />
      </div>
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-6 col-12">
                  <PerPageSelector v-model="query.perPage"
                                   :available-per-page-options="availablePerPageOptions"
                  ></PerPageSelector>
                </div>
                <div class="col-sm-3 offset-lg-3 offset-md-3 offset-sm-3 col-12">
                  <DataTableSearch v-model="query.filter"
                                   :place-holder="$t('pages.order.search')">
                  </DataTableSearch>
                </div>
              </div>
            </div>
            <b-table
                ref="orderTable"
                striped
                hover
                fixed
                show-empty
                :empty-text="$t('components.bootstrap_table.empty_text')"
                :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
                :fields="fields"
                :stacked="$store.state.app.isMobile"
                :items="getOrders"
                :filter="query.filter"
                :per-page="query.perPage"
                :sort-by="query.sortBy"
                :sort-desc="query.sortDesc"
                :current-page="query.page"
            >

              <template v-slot:cell(money)="data">
                <money-total :money="data.item.money"/>
              </template>

              <template v-slot:cell(fulfillment_channel)="data">
                <f-badge size="md" :variant="fulfillmentChips[data.item.fulfillment_channel].color">
                  {{ fulfillmentChips[data.item.fulfillment_channel].text }}
                </f-badge>
              </template>

              <template v-slot:cell(order_status)="data">
                <f-badge size="md" :variant="orderChips[data.item.order_status].color">
                  {{ orderChips[data.item.order_status].text }}
                </f-badge>
              </template>

              <template v-slot:cell(number_of_items_shipped)="data">
                {{ data.item.number_of_items_shipped }}
              </template>

              <template v-slot:cell(marketplace_id)="data">
                <market-place-chip :marketPlaceId="data.item.marketplace_id"></market-place-chip>
              </template>

              <template v-slot:cell(action)="data">
                <b-btn @click="$router.push({ name: 'order.show', params: {orderId : data.item.id}})" size="sm"
                       variant="success"> {{ $t('pages.order.show_order') }}
                </b-btn>
              </template>

            </b-table>
            <div class="row">
              <div class="col-sm">
                <Pagination v-model="query.page" :meta="orders.meta"></Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../../../components/Pagination";
import queryBuilder from "../../../mixins/queryBuilder";
import OrderService from "../../../Services/Api/OrderService";
import OrderFilter from "./OrderFilter";
import MoneyTotal from "../../../components/widgets/MoneyTotal";
import PerPageSelector from "../../../components/PerPageSelector";
import DataTableSearch from "../../../components/DataTableSearch";
import MarketPlaceChip from "../../../components/widgets/MarketPlaceChip";

export default {
  name: "OrderList",
  mixins: [queryBuilder],
  components: {
    MarketPlaceChip,
    DataTableSearch,
    PerPageSelector,
    MoneyTotal,
    OrderFilter,
    Pagination
  },
  page() {
    return {
      title: this.$t('pages.order.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      items: [
        {
          text: this.$t('pages.order.items.second'),
          href: "/",
        },
        {
          text: this.$t('pages.order.items.second'),
          active: true,
        },
      ],
      title: "Orders",
      fields: [
        {key: 'amazon_order_id', sortable: false, label: this.$t('pages.order.fields.order_id')},
        {key: 'order_status', sortable: false, label: this.$t('pages.order.fields.status')},
        {key: 'fulfillment_channel', sortable: false, label: this.$t('pages.order.fields.fulfillment')},
        {key: 'money', sortable: false, label: this.$t('pages.order.fields.total')},
        {key: 'number_of_items_shipped', sortable: false, label: this.$t('pages.order.fields.shipped')},
        {key: 'purchase_date', sortable: false, label: this.$t('pages.order.fields.purchase_date')},
        {key: 'last_update_date', sortable: false, label: this.$t('pages.order.fields.update_date')},
        {key: 'marketplace_id', sortable: false, label: this.$t('pages.order.fields.marketplace')},
        {key: 'action', sortable: false, label: this.$t('pages.order.fields.action')},
      ],
      orders: [],
      orderChips: {
        Pending: {
          color: 'secondary',
          text: this.$t('pages.order.order_chips.pending')
        },
        Unshipped: {
          color: 'warning',
          text: this.$t('pages.order.order_chips.unshipped')
        },
        PartiallyShipped: {
          color: 'light',
          text: this.$t('pages.order.order_chips.partially')
        },
        Shipped: {
          color: 'success',
          text: this.$t('pages.order.order_chips.shipped')
        },
        Canceled: {
          color: 'danger',
          text: this.$t('pages.order.order_chips.canceled')
        },
        Unfulfillable: {
          color: 'dark',
          text: this.$t('pages.order.order_chips.unfulfillable')
        },
        InvoiceUnconfirmed: {
          color: 'primary',
          text: this.$t('pages.order.order_chips.invoice')
        },
        PendingAvailability: {
          color: 'info',
          text: this.$t('pages.order.order_chips.availability')
        },
      },
      fulfillmentChips: {
        MFN: {
          color: 'primary',
          text: this.$t('pages.order.fulfillment_chips.mfn')
        },
        AFN: {
          color: 'secondary',
          text: this.$t('pages.order.fulfillment_chips.afn')
        }
      }
    }
  },
  methods: {
    async getOrders(params = this.query) {
      this.query = {...this.query, ...params}
      const query = this.buildQuery()
      const {data: orders} = await OrderService.all({query})
      this.orders = orders
      return orders.data
    },
    setDateQuery(e) {
      this.query.date = e[0] ? e.join(',') : null
      this.$refs.orderTable.refresh()
    },
    setMarketplaceQuery(e) {
      this.query.marketplace = e.map(item => item.marketplace_id).join(',')
      this.$refs.orderTable.refresh()
    },
    setFulfilment(e) {
      this.query.fulfilment = e
      this.$refs.orderTable.refresh()
    },
  },
  created() {
    this.query.sortBy = 'purchase_date'
  }
}
</script>

<style scoped>

</style>